<template>
  <div>
    <div class="ECMonitor-title">
      <div>{{ $t("BillingServices.BillExport") }}</div>
    </div>
    <Tabs v-model="activeName" @on-click="handleClickTabs">
      <!-- 导出记录 -->
      <TabPane :label="$t('BillingServices.ExportRecords')" name="1">
        <Form :model="searchDataBillExport" inline>
          <FormItem label="" v-if="companyId == 1">
            <Select
              v-model="searchDataBillExport.companyId"
              filterable
              :placeholder="$t('alarms.common.pleaseSelectCompany')"
              :transfer="true"
            >
              <Option
                :value="item.id"
                v-for="item in companyList"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="">
            <Input
              v-model="searchDataBillExport.exportRecordName"
              :placeholder="$t('BillingServices.Querybyrecordname')"
              search
              @on-search="getBillExportData"
            ></Input>
          </FormItem>
          <FormItem label="">
            <Input
              v-model="searchDataBillExport.templateName"
              :placeholder="$t('BillingServices.QuerybyTemplateName')"
              search
              @on-search="getBillExportData"
            ></Input>
          </FormItem>
          <FormItem label="">
            <Select
              v-model="searchDataBillExport.exportStatus"
              filterable
              :placeholder="$t('BillingServices.Pleaseselecttheexportstatus')"
              :transfer="true"
            >
              <Option
                :value="item.id"
                v-for="item in exportList"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="">
            <Button type="primary" @click="getBillExportData">{{
              $t("BillingServices.select")
            }}</Button>
            <Button type="primary" @click="handleExport">{{
              $t("BillingServices.export")
            }}</Button>
          </FormItem>
        </Form>
        <Table
          :columns="BillExportColumns"
          :data="BillExportTableData"
          :no-data-text="$t('common.noData')"
          style="margin-bottom:10px"
        >
          <template slot-scope="{ row, index }" slot="operation">
            <Button
              type="primary"
              size="small"
              :disabled="row.exportStatus != 1"
              @click="handleBillDownloadData(row)"
              >{{ $t("BillingServices.download") }}</Button
            >
            <Button
              size="small"
              type="primary"
              @click="handleBillDownloadNoteData(row)"
              >{{ $t("BillingServices.DownloadRecords") }}</Button
            >
          </template>
        </Table>
        <div style="margin-bottom:70px">
          <Page
            style="margin-bottom:10px"
            :total="BillExportTotal"
            :current="searchDataBillExport.pageNum"
            :page-size="searchDataBillExport.pageSize"
            :transfer="true"
            show-sizer
            @on-change="handleChangesearchDataBillExportPageNum"
            @on-page-size-change="handleChangesearchDataBillExportPageSize"
          ></Page>
        </div>
      </TabPane>
      <!-- 导出模板 -->
      <TabPane :label="$t('BillingServices.ExportTemplate')" name="2">
        <Form :model="searchDataBillExportTemplate" inline>
          <FormItem label="" v-if="companyId == 1">
            <Select
              v-model="searchDataBillExportTemplate.companyId"
              filterable
              :placeholder="$t('alarms.common.pleaseSelectCompany')"
              :transfer="true"
            >
              <Option
                :value="item.id"
                v-for="item in companyList"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="">
            <Input
              v-model="searchDataBillExportTemplate.templateName"
              :placeholder="$t('BillingServices.QuerybyTemplateName')"
              search
              @on-search="getBillExportTemplateData"
            ></Input>
          </FormItem>
          <FormItem label="">
            <Button type="primary" @click="getBillExportTemplateData">{{
              $t("BillingServices.select")
            }}</Button>
            <Button type="primary" @click="handleAddTemplate">{{
              $t("BillingServices.addtemplate")
            }}</Button>
          </FormItem>
        </Form>
        <Table
          :columns="ExportTemplateColumns"
          :data="ExportTemplateTableData"
          :no-data-text="$t('common.noData')"
          style="margin-bottom:10px"
        >
          <template slot-scope="{ row, index }" slot="operation">
            <Button
              type="primary"
              size="small"
              @click="handleExportTemplateOperData(row)"
              >{{ $t("BillingServices.Operationlog") }}</Button
            >
            <Button type="primary" size="small" @click="handleEditExportTemplateData(row)">
              {{ $t("BillingServices.edit") }}
            </Button>
            <Button
              type="error"
              size="small"
              @click="handleExportTemplateDel(row)"
              >{{ $t("BillingServices.del") }}</Button
            >
          </template>
        </Table>
        <div style="margin-bottom:70px">
          <Page
            style="margin-bottom:10px"
            :total="ExportTemplateTotal"
            :current="searchDataBillExportTemplate.pageNum"
            :page-size="searchDataBillExportTemplate.pageSize"
            :transfer="true"
            show-sizer
            @on-change="handleChangesearchDataBillExportTemplatePageNum"
            @on-page-size-change="
              handleChangesearchDataBillExportTemplatePageSize
            "
          ></Page>
        </div>
      </TabPane>
    </Tabs>
    <!-- 导出AWS账单 -->
    <Modal
      v-model="BillExportModal"
      :title="$t('BillingServices.ExportAWSbill')"
      :mask-closable="false"
      @on-cancel="handleBillExportCancel"
    >
      <Form
        :model="BillExportData"
        :label-width="120"
        ref="BillExportRef"
        :rules="BillExportRules"
      >
        <FormItem
          :label="$t('BillingServices.company')"
          v-if="companyId == 1"
          prop="companyId"
        >
          <Select
            v-model="BillExportData.companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
            style="width: 200px"
          >
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          :label="$t('BillingServices.ExportRecordName')"
          prop="exportRecordName"
        >
          <Input
            v-model="BillExportData.exportRecordName"
            style="width: 200px"
            @on-blur="handleBlur"
          ></Input>
        </FormItem>
        <FormItem
          :label="$t('BillingServices.ExportTemplate')"
          prop="exportTemplateId"
        >
          <Select
            v-model="BillExportData.exportTemplateId"
            filterable
            :placeholder="$t('BillingServices.ExportTemplate')"
            :transfer="true"
            style="width: 200px"
            @on-change="handleChangeExportTemplate"
          >
            <Option
              :value="item.id"
              v-for="item in ExportTemplateList"
              :key="item.id"
              >{{ item.templateName }}</Option
            >
          </Select>
        </FormItem>
        <FormItem :label="$t('BillingServices.Billingtimerange')" required>
          <DatePicker
            v-model="dateRange"
            type="daterange"
            placeholder="Select date and time"
            style="width: 200px"
            @on-change="handleChangeExportDataTime($event)"
          ></DatePicker>
        </FormItem>
        <FormItem
          :label="$t('BillingServices.ListFields')"
          prop="standardColumnList"
        >
          <div style="border-radius:3px;">
            <!-- 传id给后端，显示name -->
            <CheckboxGroup v-model="BillExportData.standardColumnList">
              <Checkbox
                :value="t.id"
                :label="t.name"
                v-for="t in standardColumnListByTemplate"
                :key="t.id"
                disabled
              ></Checkbox>
            </CheckboxGroup>
          </div>
        </FormItem>
        <FormItem
          :label="$t('BillingServices.Statisticalields')"
          prop="collectionColumnList"
        >
          <div style="border-radius:3px;">
            <CheckboxGroup v-model="BillExportData.collectionColumnList">
              <Checkbox
                :value="t.id"
                :label="t.name"
                v-for="t in collectColumnListByTemplate"
                :key="t.id"
                disabled
              ></Checkbox>
            </CheckboxGroup>
          </div>
        </FormItem>
        <FormItem :label="$t('BillingServices.Tagfield')">
          <div style="border-radius:3px;">
            <CheckboxGroup v-model="BillExportData.tagString">
              <Checkbox
                :value="t"
                :label="t"
                v-for="t in tagColumnList"
                :key="t"
              ></Checkbox>
            </CheckboxGroup>
          </div>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="handleBillExportCancel"
          >{{ $t("OriginalBillEntry.cancel") }}
        </Button>
        <Button type="primary" @click="handleConfirmBillExport"
          >{{ $t("BillingServices.confirm") }}
        </Button>
      </div>
    </Modal>
    <!-- 下载记录 -->
    <Modal
      v-model="downLoadModal"
      footer-hide
      :title="$t('BillingServices.DownloadRecords')"
    >
      <Table
        :columns="downLoadColumns"
        :data="downLoadTableData"
        :no-data-text="$t('common.noData')"
        style="margin-bottom:10px"
      >
      </Table>
      <Page
        style="margin-bottom:10px"
        :total="downLoadTotal"
        :current="searchDatadownLoad.pageNum"
        :page-size="searchDatadownLoad.pageSize"
        :transfer="true"
        show-sizer
        @on-change="handleChangesearchDatadownLoadPageNum"
        @on-page-size-change="handleChangesearchDatadownLoadPageSize"
      ></Page>
    </Modal>
    <!-- 添加编辑模板 -->
    <Modal
      v-model="editTemplateModal"
      :title="
        editStatus
          ? $t('BillingServices.EditTemplate')
          : $t('BillingServices.addtemplate')
      "
      :mask-closable="false"
      @on-cancel="handleEditTemplateCancel"
    >
      <Form
        :model="EditTemplateData"
        :label-width="120"
        ref="EditTemplateRef"
        :rules="EditTemplateRules"
      >
        <FormItem
          :label="$t('BillingServices.company')"
          v-if="companyId == 1"
          prop="companyId"
        >
          <Select
            v-model="EditTemplateData.companyId"
            filterable
            :disabled="editStatus"
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
            style="width: 200px"
            @on-change="handleChangeCompanyId"
          >
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          :label="$t('BillingServices.TemplateName')"
          prop="templateName"
        >
          <Input
            v-model="EditTemplateData.templateName"
            style="width: 200px"
            :disabled="editStatus"
            @on-blur="handleBlurTemplateName"
          ></Input>
        </FormItem>
        <FormItem
          :label="$t('BillingServices.Billofaccountcloudplatform')"
          prop="billingCloudPlateformType"
        >
          <Select
            v-model="EditTemplateData.billingCloudPlateformType"
            filterable
            :placeholder="$t('BillingServices.Billofaccountcloudplatform')"
            :transfer="true"
            style="width: 200px"
            :disabled="editStatus"
            @on-change="handleChangeData"
          >
            <Option
              :value="item.id"
              v-for="item in CloudplatformtypeList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          :label="$t('BillingServices.Accountlists')"
          prop="accountList"
        >
          <Select
            v-model="EditTemplateData.accountList"
            filterable
            multiple
            :placeholder="$t('BillingServices.Accountlists')"
            :transfer="true"
            style="width: 200px"
          >
            <Option
              :value="item.id"
              v-for="item in BillingdatasourceList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem
          :label="$t('BillingServices.ListFields')"
          prop="standardColumnList"
        >
          <div style="border-radius:3px;">
            <!-- 传id给后端，显示name -->
            <CheckboxGroup v-model="EditTemplateData.standardColumnList">
              <Checkbox
                :value="t.id"
                :label="t.name"
                v-for="t in standardColumnListByTemplate"
                :key="t.id"
              ></Checkbox>
            </CheckboxGroup>
          </div>
        </FormItem>
        <FormItem
          :label="$t('BillingServices.Statisticalields')"
          prop="collectionColumnList"
        >
          <div style="border-radius:3px;">
            <CheckboxGroup v-model="EditTemplateData.collectionColumnList">
              <Checkbox
                :value="t.id"
                :label="t.name"
                v-for="t in collectColumnListByTemplate"
                :key="t.id"
              ></Checkbox>
            </CheckboxGroup>
          </div>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="handleEditTemplateCancel"
          >{{ $t("OriginalBillEntry.cancel") }}
        </Button>
        <Button
          type="primary"
          v-if="!editStatus"
          @click="handleConfirmEditTemplate"
          >{{ $t("BillingServices.add") }}
        </Button>
        <Button type="primary" v-else @click="handleConfirmEditTemplate"
          >{{ $t("BillingServices.confirm") }}
        </Button>
      </div>
    </Modal>
    <!-- 操作日志 -->
    <Modal
      footer-hide
      width="800px"
      v-model="operLogModal"
      :title="$t('BillingServices.Operationlog')"
    >
      <Table
        :columns="operLogColumns"
        :data="operLogTableData"
        :no-data-text="$t('common.noData')"
        style="margin-bottom:10px"
      >
      </Table>
      <!-- <Page
        :total="operLogTotal"
        :current="operLogData.pageNum"
        :page-size="operLogData.pageSize"
        :transfer="true"
        show-sizer
        @on-change="handleChangePageNumByOperLog"
        @on-page-size-change="handleChangePageSizeByOperLog"
      ></Page> -->
    </Modal>
    <!-- 删除 -->
    <Modal v-model="delModal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ RowName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          @click="handleConfirmDel"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { getCookie } from "../../../utils/cookieUtil";
export default {
  data() {
    return {
      editStatus: false,
      BillExportModal: false,
      downLoadModal: false,
      editTemplateModal: false,
      operLogModal: false,
      delModal: false,
      isDisable: false,
      companyId: getCookie(global.companyId),
      activeName: "1",
      BillExportTotal: 0,
      ExportTemplateTotal: 0,
      downLoadTotal: 0,
      operLogTotal: 0,
      searchDataBillExport: {
        companyId: "",
        exportRecordName: "",
        templateName: "",
        exportStatus: "",
        pageNum: 1,
        pageSize: 10
      },
      searchDataBillExportTemplate: {
        companyId: "",
        templateName: "",
        pageNum: 1,
        pageSize: 10
      },
      EditTemplateData: {
        id: "",
        companyId: "",
        templateName: "",
        billingCloudPlateformType: "",
        accountList: [],
        standardColumnList: [],
        collectionColumnList: []
      },
      BillExportData: {
        companyId: "",
        exportRecordName: "",
        exportTemplateId: "",
        startDate: "",
        endDate: "",
        standardColumnList: [],
        collectionColumnList: [],
        tagString: []
      },
      searchDatadownLoad: {
        billingExportRecord: "",
        pageNum: 1,
        pageSize: 10
      },
      operLogData: {
        pageNum: 1,
        pageSize: 10
      },
      exportList: [],
      companyList: [],
      ExportTemplateList: [],
      standardColumnList: [],
      collectColumnList: [],
      tagColumnList: [],
      accountList: [],
      standardColumnListByTemplate: [],
      collectColumnListByTemplate: [],
      BillExportColumns: [
        {
          title: this.$t("BillingServices.companyName"),
          key: "companyName",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Recordname"),
          key: "exportRecordName",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Accountlists"),
          key: "accountNameList",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Billingtimerange"),
          key: "dateString",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.status"),
          key: "exportStatusName",
          minWidth: 100
        },

        {
          title: this.$t("BillingServices.TemplateName"),
          key: "templateName",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.ExportListFields"),
          key: "standardColumns",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.ExportStatisticsFields"),
          key: "collectionColumns",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Exporttagfield"),
          key: "exportTagColumn",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Exporttime"),
          key: "exportDate",
          minWidth: 100
        },
        {
          title: this.$t("ticket.list.operation"),
          key: "",
          minWidth: 120,
          slot: "operation"
        }
      ],
      BillExportTableData: [],
      BillExportRules: {
        companyId: [
          {
            required: true,
            message: this.$t("alarms.common.pleaseSelectCompany"),
            trigger: "change",
            type: "number"
          }
        ],
        exportRecordName: [
          {
            required: true,
            message: "请输入导出记录名称",
            trigger: "blur"
          }
        ],
        exportTemplateId: [
          {
            required: true,
            message: "请选择导出模板"
          }
        ],
        dateRange: [
          {
            required: true,
            message: "请选择账单时间范围",
            trigger: "blur"
          }
        ]
      },
      EditTemplateRules: {
        companyId: [
          {
            required: true,
            message: this.$t("alarms.common.pleaseSelectCompany"),
            trigger: "change",
            type: "number"
          }
        ],
        templateName: [
          {
            required: true,
            message: this.$t("BillingServices.TemplateName"),
            trigger: "blur"
          }
        ],
        billingCloudPlateformType: [
          {
            required: true,
            message: this.$t("BillingServices.Billofaccountcloudplatform")
          }
        ],
        accountList: [
          {
            required: true,
            message: this.$t("BillingServices.Accountlists"),
            trigger: "change",
            type: "array"
          }
        ],
        standardColumnList: [
          {
            required: true,
            message: "请选择列表字段"
          }
        ],
        collectionColumnList: [
          {
            required: true,
            message: "请选择统计字段"
          }
        ]
      },
      downLoadColumns: [
        {
          title: this.$t("BillingServices.Downloader"),
          key: "createdBy",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Downloadtime"),
          key: "createdTime",
          minWidth: 100
        }
      ],
      downLoadTableData: [],
      ExportTemplateColumns: [
        {
          title: this.$t("BillingServices.companyName"),
          key: "companyName",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.TemplateName"),
          key: "templateName",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Cloudplatformtype"),
          key: "billingCloudPlateformName",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Accountlists"),
          key: "accountName",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.ListFields"),
          key: "stanndardColumnName",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Statisticalields"),
          key: "collectionColumnName",
          minWidth: 100
        },
        {
          title: this.$t("ticket.list.operation"),
          key: "",
          minWidth: 100,
          slot: "operation"
        }
      ],
      ExportTemplateTableData: [],
      operLogColumns: [
        {
          title: this.$t("BillingServices.Operationmodule"),
          key: "billingFunctionModule",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Operationfield"),
          key: "operationField",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Originalvalue"),
          key: "operationOriginValue",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Newvalue"),
          key: "operationNewValue",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.Operator"),
          key: "createdBy",
          minWidth: 100
        },
        {
          title: this.$t("BillingServices.UpdateTime"),
          key: "createdTime",
          minWidth: 100
        }
      ],
      operLogTableData: [],
      RowName: "",
      CloudplatformtypeList: [],
      BillingdatasourceList: [],
      getId: "",
      getRowData: {},
      getDownloadRowData: {},
      dateRange: [],
      nameCheckStatus: false
    };
  },
  methods: {
    handleChangeCompanyId() {
      this.EditTemplateData.billingCloudPlateformType = "";
      this.EditTemplateData.accountList = [];
      this.CloudplatformtypeList = [];
      this.BillingdatasourceList = [];
      this.queryCloudPlatforms();
    },
    handleChangeData() {
      this.queryAccountsByCompanyId();
    },
    handleChangeExportDataTime(data) {
      if (data.length != 0) {
        this.dateRange[0] = this.BillExportData.startDate = data[0];
        this.dateRange[1] = this.BillExportData.endDate = data[1];
      }
      this.queryTagByTemplateIdAndDate();
    },
    handleChangeExportTemplate() {
      // 根据导出模板和账单时间范围返回tag字段接口
      this.queryTagByTemplateIdAndDate();
      this.queryStandardColumnBox();
      this.queryCollectColumnBox();
      this.getBillingTemplateById();
    },
    getBillingTemplateById() {
      if (!this.BillExportData.exportTemplateId) {
        return;
      }
      this.$api.originalBillEntry
        .getBillingTemplateById("id", this.BillExportData.exportTemplateId)
        .then(res => {
          this.BillExportData.standardColumnList = res.data.standardColumnList;
          this.BillExportData.collectionColumnList =
            res.data.collectionColumnList;
          // 列表字段回显处理
          let newArr = [];
          this.standardColumnListByTemplate.forEach(item => {
            this.BillExportData.standardColumnList.forEach(i => {
              if (item.id == i) {
                newArr.push(item.name);
              }
            });
          });
          this.BillExportData.standardColumnList = newArr;
          // 统计字段回显处理
          let newArr1 = [];
          this.collectColumnListByTemplate.forEach(item => {
            this.BillExportData.collectionColumnList.forEach(i => {
              if (item.id == i) {
                newArr1.push(item.name);
              }
            });
          });
          this.BillExportData.collectionColumnList = newArr1;
        });
    },
    handleClickTabs() {},
    // 导出记录 getdata
    getBillExportData() {
      this.$api.originalBillEntry
        .queryPagingBillingExportRecord(this.searchDataBillExport)
        .then(res => {
          this.BillExportTableData = res.data.records;
          this.BillExportTotal = res.data.total;
        });
    },
    // 导出模本 getdata
    getBillExportTemplateData() {
      this.$api.originalBillEntry
        .queryPagingBillingExportTemplate(this.searchDataBillExportTemplate)
        .then(res => {
          this.ExportTemplateTableData = res.data.records;
          this.ExportTemplateTotal = res.data.total;
        });
    },
    // 操作日志 getdata
    getOperLogData(id) {
      this.$api.originalBillEntry
        .queryOperationLogsbillingExportTemplate("id", id)
        .then(res => {
          this.operLogTableData = res.data;
        });
    },
    // 点击导出 弹出导出弹窗
    handleExport() {
      this.handleBillExportCancel();
      this.BillExportModal = true;
      this.queryBillingTemplate();
    },
    // 下载导出记录
    handleBillDownloadData(row) {
      this.$api.originalBillEntry.downLoadBilling("id", row.id).then(res => {
        let _data = res.headers["content-disposition"];
        let fileName = window.decodeURI(
          _data.substring(_data.indexOf("=") + 1)
        );
        var index = _data.lastIndexOf("=");
        _data = _data.substring(index + 1, _data.length);

        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8"
        });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
        this.modal_loading = false;
        this.$Message.destroy();
        this.$Message.success("导出成功");
      });
    },
    // 下载记录 弹出下载记录弹窗
    handleBillDownloadNoteData(row) {
      this.getDownloadRowData = row;
      this.downLoadModal = true;
      this.getDownloadNoteData(row.id);
    },
    getDownloadNoteData(id) {
      this.searchDatadownLoad.billingExportRecord = id;
      this.$api.originalBillEntry
        .queryPagingDownLoadRecord(this.searchDatadownLoad)
        .then(res => {
          this.downLoadTableData = res.data.records;
          this.downLoadTotal = res.data.total;
        });
    },
    // 导出模板-添加模板弹窗
    handleAddTemplate() {
      this.editStatus = false;
      this.editTemplateModal = true;
      this.queryCloudPlatforms();
      this.queryStandardColumnBox();
      this.queryCollectColumnBox();
    },
    // 导出模板-编辑模板弹窗
    handleEditExportTemplateData(row) {
      this.editStatus = true;
      this.getId = row.id;
      this.queryCloudPlatforms();
      this.queryStandardColumnBox();
      this.queryCollectColumnBox();
      this.editTemplateModal = true;
      this.getEditExportTemplateData();
    },
    getEditExportTemplateData() {
      this.$api.originalBillEntry
        .getBillingTemplateById("id", this.getId)
        .then(res => {
          this.EditTemplateData.id = res.data.id;
          this.EditTemplateData.companyId = res.data.companyId;
          this.EditTemplateData.templateName = res.data.templateName;
          this.EditTemplateData.billingCloudPlateformType =
            res.data.billingCloudPlateformType;
          this.EditTemplateData.accountList = res.data.accountList;
          this.EditTemplateData.standardColumnList =
            res.data.standardColumnList;
          this.EditTemplateData.collectionColumnList =
            res.data.collectionColumnList;

          // 列表字段回显处理
          let newArr = [];
          this.standardColumnListByTemplate.forEach(item => {
            this.EditTemplateData.standardColumnList.forEach(i => {
              if (item.id == i) {
                newArr.push(item.name);
              }
            });
          });
          this.EditTemplateData.standardColumnList = newArr;
          // 统计字段回显处理
          let newArr1 = [];
          this.collectColumnListByTemplate.forEach(item => {
            this.EditTemplateData.collectionColumnList.forEach(i => {
              if (item.id == i) {
                newArr1.push(item.name);
              }
            });
          });
          this.EditTemplateData.collectionColumnList = newArr1;
          this.queryAccountsByCompanyId();
          this.EditTemplateData.accountList = this.EditTemplateData.accountList.map(
            item => item.id
          );
        });
    },
    // 导出模板-操作日志
    handleExportTemplateOperData(row) {
      this.operLogModal = true;
      this.getOperLogData(row.id);
    },
    // 删除
    handleExportTemplateDel(row) {
      this.delModal = true;
      this.RowName = row.name;
      this.getRowData = row;
    },
    // 调用删除接口
    handleConfirmDel() {
      this.$api.originalBillEntry
        .deleteExportTemplate("id", this.getRowData.id)
        .then(res => {
          this.$Message.success("删除成功");
          this.delModal = false;
          this.getBillExportTemplateData();
        });
    },
    // 导出aws账单弹窗 确认事件
    handleConfirmBillExport() {
      this.$refs.BillExportRef.validate(valid => {
        if (valid) {
          if (!this.BillExportData.startDate || !this.BillExportData.endDate) {
            this.$Message.error("请选择账单时间范围");
            return;
          }
          if (this.editStatus == false) {
            this.handleBlur();
          }
          if (this.nameCheckStatus) {
            return;
          }
          this.BillExportData.collectionColumnList = undefined;
          this.BillExportData.standardColumnList = undefined;
          this.$api.originalBillEntry
            .exportBilling(this.BillExportData)
            .then(res => {
              this.$Message.success("操作成功");
              this.getBillExportData();
              this.BillExportModal = false;
              this.handleBillExportCancel();
            });
        } else {
          this.BillExportModal = true;
          this.$Message.error("请填写完整");
          return;
        }
      });
    },
    // 点击模板名称 弹窗-编辑模板确认事件
    handleConfirmEditTemplate() {
      this.$refs.EditTemplateRef.validate(valid => {
        if (valid) {
          let arr1 = [];
          this.standardColumnListByTemplate.forEach(item => {
            this.EditTemplateData.standardColumnList.forEach(i => {
              if (item.name == i) {
                arr1.push(item.id);
              }
            });
          });
          this.EditTemplateData.standardColumnList = arr1;
          // 统计字段回显处理
          let arr2 = [];
          this.collectColumnListByTemplate.forEach(item => {
            this.EditTemplateData.collectionColumnList.forEach(i => {
              if (item.name == i) {
                arr2.push(item.id);
              }
            });
          });
          this.EditTemplateData.collectionColumnList = arr2;
          if (this.editStatus == false) {
            this.handleBlurTemplateName();
          }
          if (this.nameCheckStatus) {
            return;
          }
          this.$api.originalBillEntry
            .billingExportTemplateConfirm(this.EditTemplateData)
            .then(res => {
              this.$Message.success("操作成功");
              this.getBillExportTemplateData();
              this.editTemplateModal = false;
              this.handleEditTemplateCancel();
            });
        } else {
          this.editTemplateModal = true;
          this.$Message.error("请填写完整");
          return;
        }
      });
    },
    // 失去焦点时调用去重接口，保存时也需要调用
    handleBlur() {
      if (!this.BillExportData.exportRecordName) {
        return;
      }
      this.$api.originalBillEntry
        .duplicateCheckbillingExportRecord({
          exportRecordName: this.BillExportData.exportRecordName,
          companyId: this.BillExportData.companyId
        })
        .then(res => {
          this.nameCheckStatus = false;
        })
        .catch(err => {
          this.nameCheckStatus = true;
          this.$Message.error("规则名称重复");
        });
    },
    // 失去焦点时调用去重接口，保存时也需要调用
    handleBlurTemplateName() {
      if (!this.EditTemplateData.templateName) {
        return;
      }
      this.$api.originalBillEntry
        .duplicateCheckbillingExportTemplate({
          templateName: this.EditTemplateData.templateName,
          companyId: this.EditTemplateData.companyId
        })
        .then(res => {
          this.nameCheckStatus = false;
        })
        .catch(err => {
          this.nameCheckStatus = true;
          this.$Message.error("规则名称重复");
        });
    },

    // 导出记录分页
    handleChangesearchDataBillExportPageNum(pageNum) {
      this.searchDataBillExport.pageNum = pageNum;
      this.getBillExportData();
    },
    handleChangesearchDataBillExportPageSize(pageSize) {
      this.searchDataBillExport.pageSize = pageSize;
      this.getBillExportData();
    },
    // 下载记录分页
    handleChangesearchDatadownLoadPageNum(pageNum) {
      this.searchDatadownLoad.pageNum = pageNum;
      this.getDownloadNoteData(this.getDownloadRowData.id);
    },
    handleChangesearchDatadownLoadPageSize(pageSize) {
      this.searchDatadownLoad.pageSize = pageSize;
      this.getDownloadNoteData(this.getDownloadRowData.id);
    },
    // 操作日志 分页
    // handleChangePageNumByOperLog(pageNum) {
    //   this.operLogData.pageNum = pageNum;
    //   this.getOperLogData();
    // },
    // handleChangePageSizeByOperLog(pageSize) {
    //   this.operLogData.pageSize = pageSize;
    //   this.getOperLogData();
    // },
    // 导出模板分页
    handleChangesearchDataBillExportTemplatePageNum(pageNum) {
      this.searchDataBillExportTemplate.pageNum = pageNum;
      this.getBillExportTemplateData();
    },
    handleChangesearchDataBillExportTemplatePageSize(pageSize) {
      this.searchDataBillExportTemplate.pageSize = pageSize;
      this.getBillExportTemplateData();
    },
    // 导出记录 导出aws取消事件
    handleBillExportCancel() {
      this.BillExportModal = false;
      (this.BillExportData = {
        companyId: "",
        exportRecordName: "",
        exportTemplateId: "",
        startDate: "",
        endDate: "",
        standardColumnList: [],
        collectionColumnList: [],
        tagString: []
      }),
        (this.dateRange = []);
      this.tagColumnList = [];
      this.$refs.BillExportRef.resetFields();
      this.standardColumnListByTemplate = [];
      this.collectColumnListByTemplate = [];
    },
    // 编辑模板取消事件
    handleEditTemplateCancel() {
      this.editTemplateModal = false;
      (this.EditTemplateData = {
        companyId: "",
        templateName: "",
        billingCloudPlateformType: "",
        accountList: [],
        standardColumnList: [],
        collectionColumnList: []
      }),
        this.$refs.EditTemplateRef.resetFields();
    },
    // 公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
          this.searchDataBillExport.companyId = this.companyList[0].id;
          this.searchDataBillExportTemplate.companyId = this.companyList[0].id;
        });
    },
    // 云平台下拉框
    queryCloudPlatforms() {
      this.$api.originalBillEntry.queryCloudPlatforms().then(res => {
        this.CloudplatformtypeList = res.data;
      });
    },
    // 账号列表下拉框
    queryAccountsByCompanyId() {
      if (this.EditTemplateData.billingCloudPlateformType == undefined) {
        return;
      }
      this.$api.originalBillEntry
        .queryBillingAccountByCompanyId({
          companyId: this.EditTemplateData.companyId,
          cloudPlatformsType: this.EditTemplateData.billingCloudPlateformType
        })
        .then(res => {
          this.BillingdatasourceList = res.data;
        });
    },
    // 列表字段
    queryStandardColumnBox() {
      this.$api.originalBillEntry.queryStandardColumnBox().then(res => {
        this.standardColumnListByTemplate = res.data;
      });
    },
    // 统计字段
    queryCollectColumnBox() {
      this.$api.originalBillEntry.queryCollectColumnBox().then(res => {
        this.collectColumnListByTemplate = res.data;
      });
    },
    // 导出状态
    queryExportStatus() {
      this.$api.originalBillEntry.queryExportStatus().then(res => {
        this.exportList = res.data;
      });
    },
    // 导出模板的下拉框接口
    queryBillingTemplate() {
      this.$api.originalBillEntry
        .queryBillingTemplate({ companyId: this.BillExportData.companyId })
        .then(res => {
          this.ExportTemplateList = res.data;
        });
    },
    // 根据导出模板和账单时间范围返回tag字段接口
    queryTagByTemplateIdAndDate() {
      if (
        !this.BillExportData.startDate ||
        !this.BillExportData.endDate ||
        !this.BillExportData.exportTemplateId
      ) {
        return;
      }
      this.$api.originalBillEntry
        .queryTagByTemplateIdAndDate({
          exportTemplateId: this.BillExportData.exportTemplateId,
          startDate: this.BillExportData.startDate,
          endDate: this.BillExportData.endDate
        })
        .then(res => {
          this.tagColumnList = res.data;
        });
    }
  },
  mounted() {
    // 请求公司下拉框接口
    this.getCompanyDropDownBox();
    this.queryExportStatus();
    // 如果公司不是冠闵，处理table不显示公司名称一列
    if (this.companyId != 1) {
      this.BillExportColumns = this.BillExportColumns.filter(
        item => item.key != "companyName"
      );
      this.ExportTemplateColumns = this.ExportTemplateColumns.filter(
        item => item.key != "companyName"
      );
    }
  }
};
</script>

<style scoped>
.ECMonitor-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/ebilling/OriginalBillEntry/BillingExport.vue